"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _formControl = _interopRequireDefault(require("../form-control"));

var _attach = _interopRequireDefault(require("../attach"));

var _helpToolTip = _interopRequireDefault(require("./help-tool-tip"));

var _formLabel = _interopRequireDefault(require("./form-label"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CommonField = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(CommonField, _React$PureComponent);

  var _super = _createSuper(CommonField);

  function CommonField() {
    (0, _classCallCheck2.default)(this, CommonField);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CommonField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          component = _this$props.component,
          children = _this$props.children,
          label = _this$props.label,
          required = _this$props.required,
          fullWidth = _this$props.fullWidth,
          err = _this$props.err,
          editable = _this$props.editable,
          touched = _this$props.touched,
          help = _this$props.help,
          hideLabelUI = _this$props.hideLabelUI,
          hideLabel = _this$props.hideLabel,
          useDisplayValue = _this$props.useDisplayValue,
          shrinkLabel = _this$props.shrinkLabel,
          inlineLabel = _this$props.inlineLabel,
          marginBottom = _this$props.marginBottom,
          autoHideLabel = _this$props.autoHideLabel;
      var fld = null;
      var lbl = null;
      var isBlank = component.isBlank();
      var id = component.getUniqueId();

      if (!hideLabelUI && !hideLabel && (!autoHideLabel || label)) {
        if (editable && !useDisplayValue && !inlineLabel) {
          lbl = /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
            htmlFor: id,
            error: touched && err ? true : false // If label is blank then don't show as required
            ,
            required: label && required,
            shrink: shrinkLabel
          }, label);
        } else {
          // We display a non-breaking space when the label is empty so that CompositeFields, like the
          // ChainedSelectField, print all their display values on the same line.
          var labelText = label ? label : '\u00A0';
          lbl = /*#__PURE__*/_react.default.createElement(_formLabel.default, {
            id: "label-".concat(id),
            htmlFor: id,
            error: touched && err ? true : false,
            required: required && !useDisplayValue && editable,
            shrink: useDisplayValue || !editable || shrinkLabel
          }, labelText);

          if (!inlineLabel) {
            // We wrap the label in a div tag so that the proceeding display value appears on a
            // different line
            lbl = /*#__PURE__*/_react.default.createElement("div", null, lbl);
          }
        }
      }

      var firstErr = component.getFirstErr();
      fld = /*#__PURE__*/_react.default.createElement("span", null, lbl, children, help && editable ? /*#__PURE__*/_react.default.createElement(_helpToolTip.default, {
        help: help
      }) : '', touched && err ? /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
        error: true
      }, firstErr) : null);

      if (editable || !isBlank) {
        return /*#__PURE__*/_react.default.createElement(_formControl.default, {
          fullWidth: fullWidth,
          marginBottom: marginBottom
        }, fld);
      } else {
        return null;
      }
    }
  }]);
  return CommonField;
}(_react.default.PureComponent); // 'value' is needed in the event we are showing the display value


CommonField = (0, _attach.default)(['label', 'required', 'fullWidth', 'value', 'err', 'editable', 'touched', 'help', 'hideLabel', 'useDisplayValue', 'autoHideLabel'])(CommonField);
var _default = CommonField;
exports.default = _default;